import {
    ArrowLeft,
    Bell,
    Building,
    Camera,
    Check,
    CheckCircle2,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    ChevronsLeft,
    ChevronsRight,
    ChevronsUpDown,
    Download,
    Eye,
    File,
    Inbox,
    Mail,
    MessageSquare,
    MinusCircle,
    MoreHorizontal,
    Pencil,
    Play,
    PlusCircle,
    Share2,
    ThumbsUp,
    Trash2,
    X,
} from "lucide-react";
import { fromLucide } from "./fromLucide";

/**
 * heroicons 20/solid and 24/solid names → lucide. lucide has no solid set, so
 * these keep its default (heavier) 2 stroke; shapes whose filled look carries
 * meaning (a liked thumb, an active bell, the play button) are filled.
 */
const solid = { strokeWidth: 2 };
const filled = { strokeWidth: 2, fill: "currentColor" };
// heroicons' solid set draws some shapes filled with white inner lines; the
// unread envelope and the selected-document check rely on that look. The
// check uses CheckCircle2, a closed circle (CheckCircle is an open arc and
// fills as a broken disc). Only used on light backgrounds (web is light-only).
const cutout = { strokeWidth: 1.5, fill: "currentColor", stroke: "white" };

export const ArrowDownTrayIcon = fromLucide(Download, solid, "ArrowDownTrayIcon");
export const ArrowLeftIcon = fromLucide(ArrowLeft, solid, "ArrowLeftIcon");
export const BellIcon = fromLucide(Bell, filled, "BellIcon");
export const BuildingOfficeIcon = fromLucide(Building, solid, "BuildingOfficeIcon");
export const CameraIcon = fromLucide(Camera, solid, "CameraIcon");
export const ChatBubbleBottomCenterIcon = fromLucide(
    MessageSquare,
    filled,
    "ChatBubbleBottomCenterIcon",
);
export const CheckCircleIcon = fromLucide(CheckCircle2, cutout, "CheckCircleIcon");
export const CheckIcon = fromLucide(Check, solid, "CheckIcon");
export const ChevronDoubleLeftIcon = fromLucide(ChevronsLeft, solid, "ChevronDoubleLeftIcon");
export const ChevronDoubleRightIcon = fromLucide(ChevronsRight, solid, "ChevronDoubleRightIcon");
export const ChevronDownIcon = fromLucide(ChevronDown, solid, "ChevronDownIcon");
export const ChevronLeftIcon = fromLucide(ChevronLeft, solid, "ChevronLeftIcon");
export const ChevronRightIcon = fromLucide(ChevronRight, solid, "ChevronRightIcon");
export const ChevronUpDownIcon = fromLucide(ChevronsUpDown, solid, "ChevronUpDownIcon");
export const ChevronUpIcon = fromLucide(ChevronUp, solid, "ChevronUpIcon");
export const DocumentIcon = fromLucide(File, solid, "DocumentIcon");
export const EllipsisHorizontalIcon = fromLucide(MoreHorizontal, solid, "EllipsisHorizontalIcon");
export const EnvelopeIcon = fromLucide(Mail, cutout, "EnvelopeIcon");
export const EyeIcon = fromLucide(Eye, solid, "EyeIcon");
export const HandThumbUpIcon = fromLucide(ThumbsUp, filled, "HandThumbUpIcon");
export const InboxArrowDownIcon = fromLucide(Inbox, solid, "InboxArrowDownIcon");
export const MinusCircleIcon = fromLucide(MinusCircle, solid, "MinusCircleIcon");
export const PencilIcon = fromLucide(Pencil, solid, "PencilIcon");
export const PlayIcon = fromLucide(Play, filled, "PlayIcon");
export const PlusCircleIcon = fromLucide(PlusCircle, solid, "PlusCircleIcon");
export const ShareIcon = fromLucide(Share2, solid, "ShareIcon");
export const TrashIcon = fromLucide(Trash2, solid, "TrashIcon");
export const XMarkIcon = fromLucide(X, solid, "XMarkIcon");
